<!--维修单管理-->
<template>
    <div id="repairManagement" class="business-page">
        <div class="nav-left" :class="{'nav-left-close':menuHide}">
            <el-menu
                    background-color="#F2F6FC"
                    :default-active="bsactiveIndex"
                    :default-openeds="opened"
                    class="el-menu-vertical-demo"
                    @open="handleOpen"
                    @close="handleClose">
                <el-submenu index="1">
                    <template slot="title">
                        <span>检修管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item :index="'1-'+(1+index)" class="left-nav-item" v-for="(item,index) in menu" :key="index">
                            <router-link :to="item.Url">{{item.Name}}</router-link>
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
            </el-menu>
<!--            <div class="openAndClose" @click="toggleMenu">-->
<!--                <img src="../../../assets/images/open.png" alt="">-->
<!--            </div>-->
        </div>
        <div class="business-content">
            <router-view/>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'repairManagement',
        components: {

        },
        data(){
            return {
                menuHide:false,
                opened:['1'],
                menu:[],
            }
        },
        computed:{
            bsactiveIndex(){
                return this.$store.state.navLv3
            }
        },
        mounted(){
            this.$util.getNode('检修管理',3).then((res)=>{
                this.menu = res
            })
        },
        methods:{
            toggleMenu (){
                this.menuHide = !this.menuHide
            },
            handleOpen(key, keyPath) {
                // console.log(key, keyPath);
            },
            handleClose(key, keyPath) {
                // console.log(key, keyPath);
            }
        }
    }
</script>
<style lang="less" scoped>

</style>
